import { __makeTemplateObject } from 'tslib';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';

var markResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"], ["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"])), resets.normalize.html, resets.common);
var HtmlMark = styled.mark.withConfig({
  componentId: "sc-n7q6tq-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), markResets);
var templateObject_1, templateObject_2;

export { HtmlMark };
//# sourceMappingURL=HtmlMark.js.map
